import React from 'react';

interface Props {
  stroke?: string;
}

const ArrowLeft = (props: Props) => {
    const { stroke } = props;
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 11.7004L1.4 6.90044L7 2.10044" stroke={stroke || '#B2FCE4'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.4001 6.90161L12.6001 6.90161" stroke={stroke || '#B2FCE4'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
export default ArrowLeft;
